export default () => {
  $('.js-accordion').on('click', function() {
    const accordionItem = $(this).parent();
    const accordionBody = accordionItem.find('.accordion__body');
    if (parseInt(accordionBody.css('max-height'))) {
      accordionItem.removeClass('active');
      accordionBody.css({ 'max-height': 0 });
    } else {
      accordionItem.addClass('active');
      accordionBody.css({
        'max-height': accordionBody.prop('scrollHeight') + 60 + 'px', // 60 is a 3rem x 2 padding on the element
      });
    }
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/accordion.js